<div class="sentence-wrapper" (click)="seekTo()" (dblclick)="editSentence()" [ngClass]="{editing: editing}">
  <div class="time">{{ sentence.starts_at.asMinutesSecondsString() }}</div>
  <div class="sentence" *ngIf="!editing">{{ sentence.text }}</div>
  <div class="sentence" *ngIf="editing">
    <input type="text" class="sentence-edit-input" #sentenceEditElement [formControl]="sentenceFormControl" (keyup.enter)="breakSentence()"/>
  </div>
  <div *ngIf="editing" (click)="stopProp($event)" class="folder-menu">
    <span (click)="$event.stopPropagation(); editing=false" class="fa fa-times-circle-o cancel"></span>
    <span (click)="saveSentence()" class="fa fa-check-circle save"></span>
  </div>

  <div *ngIf="!editing" (click)="stopProp($event)" class="folder-menu">
    <div ngbDropdown class="d-inline-block dropup" [placement]="'top'">
      <span class="fa fa-ellipsis-h toggle-points" id="folderMenu" ngbDropdownToggle></span>
      <div class="dropdown-menu dropdown-menu-right" aria-labelledby="folderMenu">
        <button class="dropdown-item" (click)="editSentence()"><i class="fa fa-pencil"></i> Edit</button>
        <button class="dropdown-item" (click)="mergeWithNext()"><i class="fa fa-compress"></i> Merge with next</button>
        <button class="dropdown-item" (click)="openTextEditor()"><i class="fa fa-font"></i> Open Text Editor</button>
        <button class="dropdown-item" (click)="deleteSentence()"><i class="fa fa-trash"></i> Delete</button>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/transcribe/transcribe-editor/transcribe-sentence/transcribe-sentence.component.html